import { Close } from "@mui/icons-material";
import { Grid, Typography, IconButton, Divider } from "@mui/material";
import AcxDrawer from "components/UI/Drawer/AcxDrawer";
import React from "react";

export function TitledDrawer({
    title,
    children,
    onClose,
    open,
    headerContent,
}: {
    title: string;
    open: boolean;
    children: React.ReactNode;
    onClose: () => void;
    /** Rendered under the title, inside the sticky header. */
    headerContent?: React.ReactNode;
}) {
    return (
        <AcxDrawer
            anchor="right"
            open={open}
            offsetPosition="Top"
            offsetPx={72}
            content={
                <Grid
                    container
                    direction="column"
                    flexWrap="nowrap"
                    maxWidth="384px"
                >
                    <Grid
                        container
                        item
                        sx={{ background: "white", position: "sticky", top: 0 }}
                    >
                        <Grid
                            container
                            item
                            p={2}
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item>
                                <Typography
                                    sx={(theme) => ({
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                        color: theme.palette.gray[700],
                                    })}
                                >
                                    {title}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <IconButton
                                    onClick={onClose}
                                    size="small"
                                    aria-label={`close ${title.toLowerCase()}`}
                                >
                                    <Close />
                                </IconButton>
                            </Grid>
                        </Grid>
                        {headerContent && (
                            <Grid item width="100%" px={2} pb={2}>
                                {headerContent}
                            </Grid>
                        )}
                        <Grid item width="100%">
                            <Divider />
                        </Grid>
                    </Grid>
                    {children}
                </Grid>
            }
            customRootStyles={{
                zIndex: 999,
                whiteSpace: "pre-wrap",
            }}
            onDrawerClose={onClose}
            disableEnforceFocus
            collapsible={"full"}
        />
    );
}

function TitledDrawerSection({
    children,
    ...props
}: React.PropsWithChildren<React.ComponentPropsWithoutRef<typeof Grid>>) {
    return (
        <Grid
            container
            item
            direction="column"
            rowGap={2}
            p={2}
            flexWrap="nowrap"
            {...props}
        >
            {children}
        </Grid>
    );
}

TitledDrawer.Section = TitledDrawerSection;
